import { StyleSheet } from "@react-pdf/renderer";
import { black, blue, darkGreen, red, white } from "./PDFColors";

export const styles = StyleSheet.create({
  backgroundBlue: {
    height: "100%",
    width: "100%",
    borderStyle: "solid",
    borderColor: blue,
    borderWidth: "10pt",
  },

  contentContainer: {
    height: "500px",
    width: "780px",
    borderStyle: "solid",
    borderColor: blue,
    borderWidth: "1pt",
    margin: "auto",
  },

  titleContainer: {
    height: "50px",
    width: "779px",
    borderBottomStyle: "solid",
    borderBottomColor: blue,
    borderBottomWidth: "1pt",
    marginBottom: "auto",
    display: "flex",
    flexDirection: "row",
  },

  titleContainerLeft: {
    height: "50px",
    width: "215px",
    borderRightStyle: "solid",
    borderRightColor: blue,
    borderRightWidth: "1pt",
    backgroundColor: blue,
    justifyContent: "center",
  },

  textTitleLeft: { color: white, textAlign: "center" },

  textTitleRight: { color: black, textAlign: "center", fontSize: "13px" },

  titleContainerRight: {
    height: "50px",
    width: "565px",
    justifyContent: "center",
  },

  timelineContainer: {
    width: "50%",
    height: "30%",
    position: "absolute",
    marginHorizontal: "auto",
    marginTop: "50px",
  },

  bottomContainer: {
    width: "100%",
    height: "300px",
    display: "flex",
    flexDirection: "row",
  },

  bottomLeftContainer: {
    width: "30%",
    height: "200px",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "left",
    marginTop: "50px",
  },

  bottomRightContainer: {
    width: "70%",
    height: "200px",
    marginTop: "50px",
  },

  textFounderContainer: {
    width: "120px",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },

  leaverInfoContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    marginBottom: "40px",
  },

  leaverTypeContainer: {
    width: "96px",
    height: "25px",
    backgroundColor: blue,
    justifyContent: "center",
    alignItems: "center",
  },

  textLeaverType: {
    color: white,
    fontSize: "15px",
  },

  callOptionsContainer: { marginLeft: "20px" },

  textCallOptions: {
    fontSize: "11px",
  },

  red: { color: red, marginTop: "2px", marginRight: "4px" },

  green: {
    width: "14px",
    height: "14px",
    borderStyle: "solid",
    borderRadius: "50%",
    backgroundColor: darkGreen,
    color: darkGreen,
    marginTop: "4px",
    marginRight: "4px",
  },
});
